<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    export let editable;

    export let editing;

    export let dirty;

    function toggleEditing () {
        editing = true;
    }
</script>

<style>
    button.edit-btn {
        border: none;
        background: transparent;
        padding: 0;
        margin: 0;
    }
</style>

{#if editing && dirty}
    <button class="flat flat-primary-invert"
            title="Save changes to report"
            data-action="saveReport"
            on:click={() => dispatch('save')}>Save report</button>
{/if}
{#if editing}
    <button class="flat" data-action="cancelEdit" title="Undo any changes and stop editing" on:click={() => dispatch('cancel')}>cancel</button>
{/if}
{#if editable}
    <button on:click={toggleEditing}
            title="Edit report"
            class="edit-btn"
            data-action="toggleEditing">
        <i class="icon icon-edit"
           class:active={editing}></i>
    </button>

{/if}
